import {
    fetchGetAssociatedPeopleSuggestions,
    fetchPostAssociatedPeopleSuggestionsDismiss
} from '@iwoca/lapi-client/edge';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { TSuggestion } from './MSHForm.types';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

const SUGGESTIONS_QUERY_KEY = 'fetchGetAssociatedPeopleSuggestions';

export const useAssociatedPeopleSuggestions = ({
    enabled = true
}: { enabled?: boolean } = {}): {
    suggestions: TSuggestion[];
    isLoading: boolean;
} => {
    const stateKey = useStateKey();

    const { data, isLoading } = useQuery({
        queryKey: [SUGGESTIONS_QUERY_KEY, stateKey],
        queryFn: () => fetchGetAssociatedPeopleSuggestions({ stateKey }),
        enabled
    });

    return {
        suggestions: data?.data?.suggestions || [],
        isLoading
    };
};

export const useDismissSuggestion = () => {
    const stateKey = useStateKey();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (suggestion: TSuggestion) =>
            fetchPostAssociatedPeopleSuggestionsDismiss({
                stateKey,
                body: {
                    first_name: suggestion.first_name,
                    last_name: suggestion.last_name,
                    source: suggestion.source
                }
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [SUGGESTIONS_QUERY_KEY, stateKey]
            });
        }
    });
};
